export default (reducer, initialState) => ({ reducer, initialState })
